import { createSelector } from "@reduxjs/toolkit";

const initialState = {
  elementsDialog: {},
};

export const elementsDialogSelector = () =>
  createSelector(
    (state) => state.elementsDialog,
    (elementsDialog) => {
      return { ...initialState, ...(elementsDialog || {}) };
    },
  );
